const layerZero = 0;
const above = 1;
const multiplier = 10; // to scale for Popup's zIndex of [min 30, max 50] (@workday/canvas-kit-popup-stack/lib/PopupStack.ts)

const layerOne = above + layerZero;
const layerTwo = above + layerOne;
const layerThree = above + layerTwo;
const layerFour = above + layerThree;
const layerFive = above + layerFour;
const layerSix = above + layerFive;
const layerSeven = above + layerSix;
const layerEight = above + layerSeven;
const layerNine = above + layerEight;

const layerFifty = layerFive * multiplier;
const layerSixty = layerSix * multiplier;
// const layerSeventy = layerSeven * multiplier;
const layerEighty = layerEight * multiplier;
const layerNinety = layerNine * multiplier;
const layerHundred = (above + layerNine) * multiplier;

export const ZIndex = {
  // 1
  appBuilderHeader: layerOne,
  appBuilderExpandCollapseButton: layerOne,
  footer: layerOne,
  navigationTab: layerOne,
  operationContentBody: layerOne,
  fullScreenButton: layerOne,
  // 2
  appBuilderCommandPrompt: layerTwo,
  appBuilderBottomPanel: layerTwo,
  resizableGrid: layerTwo,
  pageBuilderCard: layerTwo,
  // 3
  copilotChatBubble: layerThree,
  // 4
  companySwitcher: layerFour,
  devsiteHeader: layerFour,
  // 30
  // Popper Modal layer has z-index 30
  // Form.Select dropdowns from Cargo have z-index 30
  // 40
  // 50
  clientSecretCopiedTooltip: layerFifty,
  loadingOverlay: layerFifty,
  navBarDropdownMenu: layerFifty,
  screenshotCanvas: layerFifty,
  graphqlContainer: layerFifty,
  // 60
  toast: layerSixty,
  // 70
  // 80
  selectMenu: layerEighty,
  // 90
  selectMenuTooltip: layerNinety,
  // 100
  searchBox: layerHundred,
};
